app.controller("ExamsManagerEditItemController", [
    "$scope", "ExamsManagerService", "$uibModalInstance", "$state", "$uibModal", "toastr", "params",
    function ($scope, ExamsManagerService, $uibModalInstance, $state, $uibModal, toastr, params) {
        console.log(params);

        $scope.examItem = params.examItem;

        $scope.chosenSession = null;
        $scope.chosenSeat = null;

        $scope.edit = function () {
            var seatVal = 0;
            if ($scope.chosenSeat) {
                seatVal = $scope.chosenSeat;
            }
            ExamsManagerService.editExamItem({
                examItemId: $scope.examItem._id,
                sessionId: $scope.chosenSession._id,
                seat: seatVal
            }).then(function () {
                toastr.success('', 'გამოცდა რედაქტირებულია');
                $uibModalInstance.close();
            });
        };

        $scope.getSessionsWithFreeSeats = function () {
            return ExamsManagerService.getSessionsWithFreeSeats().then(function (data) {
                $scope.sessions = data;
            });
        };

        $scope.getSessionsWithFreeSeats();

        $scope.itemChanged = function () {
            $scope.chosenSeat = null;
            $scope.chosenSession = $scope.sessions.filter(function (e) {
                return e._id === $scope.session;
            })[0];
            // console.log($scope.chosenSession);
            $scope.seats = $scope.chosenSession.seats;
        };

        $scope.seatChanged = function () {
            // console.log($scope.chosenSeat);
            // console.log($scope.chosenSession);
            // console.log($scope.chosenSession.examHall.withComputers);
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        function changeStatus(status, toastMessage) {
            return ExamsManagerService.changeItemStatus({status: status, examItemId: params.examItem._id}).then(function () {
                toastr.success('', toastMessage);
                $uibModalInstance.close();
            });
        }

        $scope.approve = function () {
            return changeStatus('approved', 'გამოცდა ნებადართულია');
        };

        $scope.conditionalApprove = function () {
            return changeStatus('conditional', 'გამოცდა ნებადართულია წინაპირობით (მაგ. ქვითარი)');
        };

        $scope.reject = function () {
            return changeStatus('rejected', 'გამოცდის მოთხოვნა უარყოფილია');
        };
    }
]);
